import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TipoDocumentoApi } from '../../core/models/documento';

@Injectable({
  providedIn: 'root',
})
export class ParametrizacaoService {
  constructor(private httpClient: HttpClient) {}

  /** Catálogo de tipos de documento (endpoint público). */
  async listarTiposDocumento(): Promise<TipoDocumentoApi[]> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.ocpapimsubscriptionkeyParametrizacao,
    });
    const url = `${environment.baseUrl}/${environment.parametrizacaoBaseUrl}/v1/publico/tipos-documento`;
    return lastValueFrom(this.httpClient.get<TipoDocumentoApi[]>(url, { headers }));
  }
}
